import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./protectedRoute";
import PrivateRoute from "./privateRoute";
import Home from "../modules/home/home";
import Dashboard from "../modules/dashboard/dashboard";
import ProductList from "../modules/products/products";
import ProductForm from "../modules/products/createEditProduct";
import PosBilling from "../modules/pos/billing";
import AccountDetails from "../modules/account/account";
import Transactions from "../modules/transactions/transactions";
import { ToastContainer } from "react-toastify";
import InvoiceView from "../modules/transactions/invoice-view";
import ResetPasswordPage from "../modules/auth/resetPassword";
import Success from "../modules/payments/stripe/success";
import Cancel from "../modules/payments/stripe/cancel";
import Subscription from "../modules/subscription/subscription";
import SubscriptionList from "../modules/subscription/subscription-list";
import TermsAndConditions from "../modules/termsAndPolicy/termsAndCondition";
import PrivacyPolicy from "../modules/termsAndPolicy/privacyPolicy";
import { accountDetailsAction } from "../redux/actions/authAction";
import { useDispatch } from "react-redux";
import { errorToast } from "../components/toast";
import ProductBilling from "../modules/pos/productBilling";

const MainRoute = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        // const alreadyFetched = sessionStorage.getItem('apiCalledThisSession');
        if (localStorage.getItem("accessToken")) {
         fetchAccount()
        }
    }, []);

    const fetchAccount = () => {
        dispatch(accountDetailsAction({}, (data) => {
            localStorage.setItem('storeData', JSON.stringify(data.data.data));
            // sessionStorage.setItem('apiCalledThisSession', 'true');
        }, onError))
    }

    const onError = (data) => {
        errorToast(data.data.message);
    };

    return (
        <>
            <Router>
                <Routes>
                    <Route element={<ProtectedRoute />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                        {/* <Route path="/login" element={<LoginForm />} /> */}
                        {/* <Route path="/register" element={<RegistrationForm />} /> */}
                    </Route>

                    <Route element={<PrivateRoute />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/products" element={<ProductList />} />
                        <Route path="/product/create" element={<ProductForm />} />
                        <Route path="/product/edit/:id" element={<ProductForm />} />
                        <Route path="/pos/billing" element={<PosBilling />} />
                        <Route path="/account" element={<AccountDetails />} />
                        <Route path="/transactions" element={<Transactions />} />
                        <Route path="/invoice" element={<InvoiceView />} />
                        <Route path="/subscribe" element={<Subscription />} />
                        <Route path="/subscriptions" element={<SubscriptionList />} />
                        <Route path="/billing" element={<ProductBilling />} />

                        {/* <Route path="/support" element={<Support />} /> */}
                    </Route>
                    <Route path="/success" element={<Success />} />
                    <Route path="/cancel" element={<Cancel />} />
                    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                </Routes>
                <ToastContainer limit={2} />
            </Router>
        </>
    );
};

export default MainRoute;
